{
  "commons": {
    "incomplete": "Incomplete",
    "requiredQuestion": "Required",
    "completed": "Completed",
    "invalid": "Invalid",
    "saving": "Saving",
    "uploading": "Uploading",
    "saved": "Saved",
    "and": "and",
    "month": "month",
    "month_other": "months",
    "year": "year",
    "year_other": "years",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "viewFile": "View file",
    "downloadFile": "Download file",
    "downloadFileError": "Failed to download file. Please try again.",
    "support": {
      "assignedToAdminUser": "<b>Questions?</b><br/> Contact {{firstName}}: <a>{{mobilePhoneNumber}}</a>",
      "default": "<b>Questions?</b><br/> Contact Us: <a>{{mobilePhoneNumber}}</a>",
      "contactUs": "Contact Us: "
    },
    "processSteps": {
      "improveLoanApplication": "Fill in information & submit",
      "improveLoanApplicationSubheading": "{{ numAnswered }} of {{ numQuestions }} answered",
      "compareBids": "Choose from offers",
      "bidSelected": "Receive funds"
    },
    "footer": {
      "chatCta": "Open chat"
    },
    "app": {
      "title": {
        "loanAppForm": "Loan application form",
        "factoringAppForm": "Factoring application form",
        "preliminaryBidForm": "Estimate your credit limit",
        "realEstateForm": "Real Estate application form",
        "leasingForm": "Leasing application form",
        "improveApp": "Improve your application",
        "dashboard": "Dashboard",
        "selectedLenderResponse": "Questions from the lender",
        "advice": "Advice",
        "application": "Apply"
      }
    },
    "contactCustomerServiceDialog": {
      "support": "Support",
      "contactCustomerService": "Contact customer service",
      "needHelp": "Need help?",
      "contactUs": "Contact our customer service.",
      "customerServiceOpen": "Open ",
      "customerServiceClosed": "Customer service closed",
      "customerServiceClosedMessage": "Customer service closed – call us {{openHours}} or contact us by email",
      "contactYourAdvisor": "Contact your advisor ({{advisorName}})",
      "bookMeetingWithAdvisor": "Book a meeting with your advisor"
    }
  },
  "login": {
    "heading": "Log in",
    "canceledTitle": "Login aborted",
    "startBankId": "Identify yourself",
    "bankIdGeneric": "Mobile BankID",
    "bankIdOnAnotherDevice": "BankID on other device",
    "bankIdOnThisDevice": "BankID on this device",
    "bankIdOnTestFlow": "With SSN (only for testing)",
    "bankIdQrCodeManual": {
      "title": "Do this",
      "step1": "Start the Mobile BankID app",
      "step2": "Click on the QR icon in the app",
      "step3": "Point the camera at the QR code displayed here on the screen",
      "step4": "Identify yourself in the app"
    },
    "autostart": {
      "title": "Attempting to Start the BankID App",
      "description": "If you do not have the BankID app installed on the same device you are using, then click on 'BankID on other device' below."
    },
    "writeSecurityCode": "Identify yourself in the app",
    "giveValidSSN": "Provide a valid SSN.",
    "noApplicationForSSN": "There are no applications for the provided SSN",
    "pleaseWait": "Please wait",
    "SSN": "SSN",
    "SSNHelper": "SSN is used to ensure your information is protected from unauthorised access",
    "continue": "Continue",
    "loginCancelled": "You have chosen to abort your login.",
    "loginError": "Your login has been aborted. Please try again. If the problem persists, please contact customer service.",
    "abortLogin": "Cancel login",
    "back": "Back"
  },
  "errors": {
    "404": {
      "heading": "Page not found",
      "subheading": "The page you are trying to access doesn't seem to exist.",
      "cta": {
        "user": "Go back",
        "notUser": "Go to homepage"
      }
    },
    "fieldRequest": {
      "generic": "Something went wrong. Please try again, or contact support if the problem persists."
    }
  },
  "openBankingData": {
    "isCompany": {
      "title": "Select business accounts in the next step",
      "cta": {
        "notOnboarded": "Share bank statement",
        "isOnboarded": "Share another bank statement"
      }
    },
    "connectBank": "Connect your business bank",
    "clickToConnectBank": "Click below to connect to your business bank",
    "successfullyConnected": "Your account has been successfully connected.",
    "shareBankStatement": "Share bank statement",
    "shareAnotherBankStatement": "Share another bank statement",
    "selectRevenueBank": "Select the bank to which your company receives customer payments.",
    "showAllBanks": "Show all banks",
    "selectRevenueAccounts": "Select the accounts to which you receive customer payments",
    "confirmRevenueAccounts": "Confirm revenue accounts",
    "selectAtLeastOneAccount": "Please select at least one account",
    "isPrivate": {
      "optional": "Optional: ",
      "title": "Connect your bank accounts to verify your income.",
      "cta": "Share private account statements"
    },
    "chooseBank": "Choose bank",
    "showMore": "Show more",
    "success": "Account statements retrieved",
    "error": "Something went wrong. Try again or contact customer service",
    "selectionError": "Something went wrong. Make sure your browser is not blocking a popup/new tab."
  },
  "slider": {
    "enterValueManually": "Enter value",
    "backToSlider": "Back to slider"
  },
  "applicationForm": {
    "startOver": "Start over",
    "testimonials": {
      "smallBusinessesTrustUs": "Small businesses trust us",
      "previousSlide": "Previous",
      "nextSlide": "Next",
      "showTestimonial": "Show {{company}}",
      "saltoMarin": {
        "organization": "Saltö Marin",
        "type": "REAL ESTATE LOAN",
        "turnover": "TURNOVER:",
        "loan": "LOAN:",
        "text": "I think it was a good way to compare different conditions, especially now that the big banks are not as interested. The process via Krea is significantly faster and saves time compared to going directly to the bank.",
        "author": "Mats Lindqvist",
        "role": "CEO"
      },
      "willBrand": {
        "organization": "Will Brand",
        "type": "TRADE",
        "turnover": "TURNOVER:",
        "loan": "LOAN:",
        "text": "We are growing faster than we expected and our webshop for companies needed a boost at the same time as we needed to prepay the production of two large autumn projects. At Krea, it works surprisingly quickly and you get nice and good treatment from their service staff. The process was much smoother compared to the old fashioned \"banking world\".",
        "author": "Pierre Gasslander",
        "role": "CEO"
      },
      "elfantminer": {
        "organization": "Elfantminer",
        "type": "LOCATION: LOHJA",
        "turnover": "LENDER: SME FINANCE",
        "loan": "LOAN:",
        "text": "Bidding was easy to do and the terms of the loan offers received through Kredita were easy to understand. During the loan negotiations, there was a feeling that all parties were genuinely interested in the company's business and were ready to seek a solution to meet the company's needs. Kredita's financial advisor kept the wheels turning and the money was deposited into the account in a few weeks.",
        "author": "Kristian Savela",
        "role": "Founder"
      },
      "tradgardsvis": {
        "organization": "Trädgårdsvis AB",
        "type": "GARDENING",
        "turnover": "REVENUE:",
        "membership": "MEMBER OF FÖRETAGARNA",
        "text": "The process with Krea was fast and smooth. The advisor at Krea was very professional, and overall it was a pleasant experience.",
        "author": "Jimmy Amberin",
        "role": "CEO"
      },
      "qickMobility": {
        "organization": "Qick Mobility AB",
        "type": "TRANSPORT",
        "turnover": "REVENUE:",
        "text": "It was a very good opportunity for us, as there was a company in Germany that was closing down its operations. But we were under some time pressure, which made the situation harder because we needed external financing. Without Krea it would have been difficult, and it is not certain that this deal would have gone through. We will absolutely use Krea again in the future.",
        "author": "Milad Mahmoudyan",
        "role": "Founder"
      },
      "quoteRegion": "Testimonial from {{company}}"
    },
    "common": {
      "startApplicationHeading": "Get offers",
      "startApplicationSubheading": "Enter your details",
      "customerCompanyLabel": "Customer company",
      "backToHome": "Back to Home",
      "getStarted": "Get started",
      "privacyPolicy": "privacy policy",
      "privacyPolicyConsent": "I accept that {{company}} is processing my <1>personal data</1>",
      "businessNotFoundContactSupport": "Can't find your business? ",
      "applicationExists": "It looks like you already have an existing application.",
      "loginToApplication": "Login to application",
      "limitedCompanyConfirmation": "Limited company",
      "customer": "The customer",
      "partner": "You / partner",
      "back": "Back",
      "continue": "Continue",
      "kreaFullName": "Krea Technology AB",
      "kreditaFullName": "Kredita Oy",
      "kreaRegisteredBy": "is authorised and registered by the Swedish Financial Supervisory Authority",
      "kreditaIsPartOf": "is part of ",
      "kreditaRegisteredBy": "which is authorized and registered by the Swedish Financial Supervisory Authority",
      "anyQuestions": "Do you have any questions?",
      "happyToHelp": "Our advisory team is happy to help you with any financing-related questions",
      "yourPersonalAdvisor": "Your personal advisor: {{advisorName}}",
      "reachOutToYourAdvisor": "Please contact me if you have any questions about your financing. I am happy to help you!",
      "callUs": "Call us on",
      "primaryPurposeHeading": "What is the primary purpose?",
      "selectMainReason": "If more than one reason applies, select the main reason",
      "buyOrLeaseAnAsset": "Buy or lease an asset",
      "purchaseOfSupply": "Purchase of supply",
      "expansion": "Expansion",
      "shortTermLiquidity": "Short-term liquidity",
      "refinancing": "Refinancing",
      "realEstate": "Real estate",
      "invoiceFinance": "Invoice finance",
      "acquisitionFinance": "Acquisition finance",
      "otherReason": "Other reason",
      "realEstateSubheading": "Can you specify what exactly the financing is for?",
      "bridgeFinancing": "Bridge financing",
      "projectFinance": "Project finance",
      "purchaseNewProperty": "Purchase new property",
      "refinanceALoan": "Refinance a loan",
      "renovationOfProperty": "Renovation of property",
      "otherPropertyFinance": "Other property finance",
      "realEstateExtendedHeading": "What is the property unit designation?",
      "invoiceFinanceSubheading": "Can you provide a few more details about your sales invoices?",
      "totalInvoiceValue": "Total invoice value each month",
      "valuePlaceholder": "500 000",
      "invoicesAmountPlaceholder": "20",
      "invoicesSuffix": "invoices",
      "numberOfInvoices": "Number of invoices each month",
      "averagePaymentTime": "Average invoice due days",
      "days": "days",
      "describeLargestInvoices": "Can you describe the largest three invoices?",
      "largestInvoicesPlaceholder": "Company name, industry, monthly amount and type of service that is sold",
      "buyOrLeaseHeading": "You want to buy or lease an asset",
      "buyOrLeaseSubheading": "Can you provide a few more details about your purchase?",
      "price": "Price (excluding VAT)",
      "objectType": "Type of object",
      "car": "Car",
      "machine": "Machine",
      "constructionMachine": "Construction machine",
      "restaurantEquipment": "Restaurant equipment",
      "itOfficeEquipment": "IT/Office equipment",
      "retailEquipment": "Retail equipment",
      "gymEquipment": "Gym equipment",
      "truck": "Truck",
      "other": "Other",
      "uploadOrLinkObject": "Please upload an offer or provide a link to the object",
      "linkPlaceholder": "https://company…",
      "offerOrLink": "Offer for object(s) or a link to the object",
      "uploadFile": "Upload file",
      "linkToObject": "Link to object",
      "financingAmountHeading": "How much financing do you need?",
      "financingUpTo": "Financing up to ",
      "notSureHowMuchToApplyFor": "Not sure how much you should apply for? ",
      "seeHowMuchYouQualifyFor": "See how much you qualify for first",
      "identificationHeading": "Identify yourself",
      "weAreObligedToIdentifyYou": "We are obliged by regulation to identify you and verify your relation to {{companyName}}.",
      "noApplicationOrCreditCheck": "No application or credit check will be created in this step.",
      "noApplication": "No application will be created in this step.",
      "acceptTermsAndConditions": "By identifying you accept the <1>terms and conditions</1>",
      "minimumFinancingAmountValidation": "The minimum amount to apply for is {{amount}}"
    },
    "commons": {
      "heading": "Choose from offers of 30 banks and lenders",
      "subHeading": "No application or credit check will be created in this step.",
      "requestedAmountPreLabel": "Desired financing",
      "requestedAmountLabel": "Choose amount",
      "exactRequestedAmountButton": "Enter exact amount",
      "exactRequestedAmountPlaceholder": "1 000 000",
      "exactRequestedPeriodButton": "Enter value",
      "requestedAmountErrors": {
        "invalidAmount": "Choose amount",
        "typeError": "Use numbers only",
        "required": "Choose amount"
      },
      "reasonLabel": "Purpose",
      "reasonPlaceholder": "Choose purpose",
      "reasonLabelTooltip": "In the next step you will be able to explain your purpose in detail and add any additional information and securities before you choose to submit your application.",
      "reasonCategories": {
        "investments": "Investments",
        "working_capital": "Cash flow",
        "real_estate": "Real estate",
        "real_estate_description": "Financing for property acquisitions, refinancing, renovations, bridge loans and project-based real estate investments.",
        "other": "Other"
      },
      "reasons": {
        "object_financing": {
          "title": "Buy or lease an asset",
          "description": "Finance vehicles, machinery or business equipment."
        },
        "supply": {
          "title": "Purchase of supply",
          "description": "Finance build-up or expansion of inventory to meet demand."
        },
        "expansion": {
          "title": "Expansion",
          "description": "Capital to grow your business, hire staff, or open new locations."
        },
        "short_term_liquidity": {
          "title": "Short-term liquidity",
          "description": "Cover temporary cash flow gaps and operating expenses."
        },
        "refinancing": {
          "title": "Refinancing",
          "description": "Replace or consolidate existing loans to secure better terms."
        },
        "invoice_financing": {
          "title": "Invoice financing",
          "description": "Unlock cash by financing outstanding invoices."
        },
        "acquisition_financing": {
          "title": "Acquisition financing",
          "description": "Finance the acquisition of companies or strategic assets."
        },
        "other": {
          "title": "Other reason",
          "description": "For financing needs that are not covered by the other alternatives."
        },
        "bridge_financing": {
          "title": "Bridge financing",
          "description": "Short-term funding until long-term financing or a transaction is completed."
        },
        "project_financing": {
          "title": "Project financing",
          "description": "Financing for specific projects within the business."
        },
        "purchase_real_estate": {
          "title": "Purchase new property",
          "description": "Finance the acquisition of commercial properties or premises."
        },
        "refinance_real_estate_loan": {
          "title": "Refinance real estate loan",
          "description": "Improve terms or release capital from existing real estate loans."
        },
        "renovation_of_property": {
          "title": "Renovation of property",
          "description": "Finance construction, remodeling or property upgrades."
        },
        "other_property_finance": {
          "title": "Other property finance",
          "description": "For other real estate-related financing needs."
        },
        "property": "Real estate",
        "machine": "Machine financing",
        "consumables": "Financing company running costs (hiring, marketing, consumables)",
        "capital": "Liquidity awaiting payment",
        "other_property": "Other property financing",
        "project": "Project financing",
        "new_business": "Finance of new business costs",
        "restoration": "Restoration of property/Real-estate",
        "season_investment": "Season investment",
        "vehicle": "Purchase or restoration of vehicle"
      },
      "reasonErrors": {
        "required": "Purpose is required"
      },
      "companyNameLabel": "Your company ",
      "companyNamePlaceholder": {
        "SE": "Company AB or XXXXXX-XXXX",
        "FI": "Company OY or XXXXXXX-X"
      },
      "companyNameFindHelp": "Can't find your company? Enter your organisation number.",
      "companyNameErrors": {
        "orgNumberRequired": "Organisation number is required",
        "orgNumberInvalid": "Enter a valid organisation number",
        "orgNameRequired": "Organisation name is required"
      },
      "companyNameChange": "Change",
      "companyNameSelect": "Select",
      "companyNamePreloader": "Searching...",
      "emailLabel": "Email",
      "emailPlaceholder": {
        "SE": "contact@company.se",
        "FI": "contact@company.fi"
      },
      "emailTooltip": "We need your email to be able to contact you regarding relevant financing offer for your company. You will always be able to unsubscribe if you no longer want to receive information from us.",
      "emailErrors": {
        "invalid": "Invalid email",
        "required": "Email is required",
        "alreadyExist": "Enter another email",
        "validationError": "Please enter a valid e-mail address"
      },
      "ssnLabel": "Social security number",
      "ssnPlaceholder": "YYYYMMDDXXXX",
      "ssnErrors": {
        "invalid": "Invalid social security number",
        "required": "Social security number is required"
      },
      "phoneLabel": "Mobile phone number",
      "phonePlaceholder": {
        "SE": "070 000 00 00",
        "FI": "050 0000 000"
      },
      "phoneErrors": {
        "invalid": "Phone number is invalid",
        "required": "Phone number is required",
        "incorrectLength": "Phone number is too short",
        "containsSpecialCharacters": "Phone number can only contain numbers"
      },
      "consentCheckboxError": "You have to approve that we process your personal data",
      "unpaidInvoicesValidation": {
        "unpaidInvoicesEstimatedRequired": "Desired value required",
        "unpaidInvoicesEstimatedInvalid": "Only numbers",
        "numberOfUnpaidInvoicesRequired": "Approximate quantity required",
        "numberOfUnpaidInvoicesInvalid": "Only numbers",
        "descriptionUnpaidInvoicesRequired": "Description of the 3 biggest invoices is required"
      },
      "identifyCta": "Identify yourself and continue",
      "tosInfo": "By identifying you accept the <1>terms and conditions</1>",
      "loggedInFormCta": "Get offers"
    },
    "factoring": {
      "heading": "Get multiple offers on factoring",
      "subHeading": "No credit check will be made in this step."
    },
    "preliminaryBid": {
      "heading": "Get real offers"
    },
    "realEstate": {
      "heading": "Choose from offers of several banks and lenders",
      "subHeading": "No application or credit check will be created in this step.",
      "fields": {
        "propertyUnitDesignation": {
          "label": "Property unit designation",
          "tooltip": "In the next step you can add more information about the properties",
          "placeholder": "Property name 11:1",
          "errors": {
            "required": "Property unit designation is required"
          }
        }
      }
    },
    "leasing": {
      "heading": "Find the best leasing offer",
      "fields": {
        "objectType": {
          "label": {
            "appForm": "Type of object",
            "fieldRequest": "Type of object"
          },
          "placeholder": "Choose object type",
          "tooltip": "In the next step you can add more information about the least object.",
          "errors": {
            "required": "Type of object is required"
          }
        },
        "objectDescription": {
          "label": "Description",
          "freetext": "Description could include: brand, name of the supplier and condition (new or used)"
        },
        "amount": {
          "label": "Price (excluding VAT)",
          "placeholder": "e.g. 450 000 {{currency}}",
          "errors": {
            "required": "Price is required"
          }
        },
        "offer": {
          "label": "Offer for object(s) or a link to the object",
          "tabs": {
            "link": "Link",
            "file": "File"
          },
          "links": {
            "link": {
              "label": {
                "appForm": "Link to the object",
                "fieldRequest": "Link to the specific object"
              },
              "placeholder": "https://company.com/my-lease-object-description",
              "errors": {
                "empty": "URL link to the object must not be empty",
                "notUrl": "Link to the object should be url link"
              }
            }
          },
          "errors": {
            "empty": "Add more information for the lease object(s)"
          }
        }
      }
    },
    "formSwitcher": {
      "label": "Select product",
      "companyLoanTab": "Company loan",
      "factoringTab": "Factoring",
      "realEstateLoanTab": "Real estate loan",
      "leasingTab": "Leasing"
    }
  },
  "iaq": {
    "whyImportantHeading": "Why do banks and lenders need this information?",
    "questionsList": "Show all questions",
    "nextQuestionCta": "Continue",
    "skipQuestionCta": "Skip question",
    "previousQuestionCta": "Back",
    "reviewApplicationGoTo": "Next",
    "contactCustomerSupport": "Contact customer service",
    "uploadedFiles": "Uploaded files",
    "save": "Save",
    "edit": "Edit",
    "add": "Add",
    "close": "Done",
    "cancel": "Cancel",
    "progressBar": {
      "steps": "Question {{currentStep}} of {{stepsQty}}",
      "optional": "(Optional)"
    },
    "advice": {
      "digitalAdviceTitle": "Improve your application",
      "digitalAdviceSubheading": "We identified possible improvements",
      "manualAdviceSubheading": "You will be contacted by your advisor within one working day",
      "title": "Your business qualifies for personal advisory",
      "titleDone": "Your business qualifies for personal advisory",
      "doYouHaveQuestions": "Do you have questions?",
      "applicationAttractiveness": "Your application's attractiveness",
      "applicationAttractivenessComparableValueTooltip": {
        "paragraph1": "Your application's attractiveness is based on Krea's database of previous customers.",
        "paragraph2": "Our estimate is based predominantly on the company's credit rating and information for potential guarantors.",
        "paragraph3": "You can improve your company's chances of getting better offers by adding more information and more collateral to your application."
      },
      "applicationAttractivenessGrades": {
        "belowAverage": "Below average",
        "average": "Average",
        "excellent": "Excellent"
      },
      "provideMoreDetailsWhileWaitingAdviceBypassDisabled": "Answer at least one question to send in application directly - alternatively, we will be in touch within 1 working day.",
      "provideMoreDetailsWhileWaiting": "Provide more details, while you wait to be contacted",
      "yourAdvisor": "Your Advisor",
      "yourAdvisorIsHappyToAssist": "Your advisor is happy to assist",
      "improveApplicationWithImprovements": "Improve your application by applying our suggestions below.",
      "allImprovementsSolved": "Thank you! You applied all our recommendations and should now have a higher likelihood to receive good offers.",
      "allImprovementsDismissed": {
        "title": "You decided to not apply all of our recommendations.",
        "subtitleDigitalAdvice": "By clicking \"Submit without improvements\", you will start to receive offers shortly.",
        "subtitleAdvice": "Your Advisor will be in touch with you within 24 hours to further improve your application."
      },
      "whyIsScoreNot100%": "Why is my score not 100%?",
      "whyIsScoreNot100%Modal": {
        "paragraph1": "Your application's attractiveness is based on Krea's database of previous customers.",
        "paragraph2": "Our estimate is based predominantly on the company's credit rating, information of guarantors and what information you have been adding to the application.",
        "paragraph3": "Your score might not reach 100% if your credit rating is not as strong or you have only recently started your business."
      },
      "okButton": "OK",
      "actions": {
        "title": {
          "getAdvice": "Improve your chances through advisory",
          "adviceWithout": "Do you want to send in the application without advisory?"
        },
        "button": {
          "adviceCta": "Book advisory meeting",
          "adviceBack": "Go back",
          "adviceWithout": "Send in without advisory",
          "adviceDigital": "Submit application",
          "adviceDigitalWithoutChanges": "Submit without improvements",
          "improveApplication": "Improve application"
        }
      }
    },
    "guarantor": {
      "explanation": {
        "text": {
          "heading": "Choose possible guarantors",
          "default": "Adding a guarantor at this stage is non-binding.",
          "soleTrader": "The owner of a sole trader company acts as a guarantor for the loan by default.",
          "partnership": "The owners of a partnership company act as the guarantors for the loan by default."
        },
        "tooltip": "A guarantor is liable to pay in case of payment difficulties in the company. Adding a guarantor is important to receive as good financing offers as possible.",
        "tooltipTrigger": "What is a guarantor?",
        "infoTextTitle": "Unsure about adding a guarantor now?",
        "infoText": "It is optional and can be added later in the process."
      },
      "me": "Myself",
      "addAnotherGuarantorQuestion": "",
      "addAnotherGuarantorOpen": {
        "empty": "Add another guarantor",
        "notEmpty": "Add an additional guarantor"
      },
      "addContactDetails": "Add contact details",
      "editContactDetails": "Edit contact details",
      "addAnotherGuarantorClose": "Close",
      "personalNumberLabel": "Guarantor's personal number",
      "personalNumberPlaceholder": {
        "SE": "YYYYMMDD-XXXX",
        "FI": "DDMMYY-NNNT"
      },
      "personalNumberInvalid": "Enter a valid personal number",
      "emailLabel": "Guarantor's email",
      "emailPlaceholder": "Email",
      "emailInvalid": "Enter a valid email",
      "phoneLabel": "Guarantor's mobile number",
      "phonePlaceholder": "Mobile number",
      "phoneInvalid": "Enter a valid mobile number",
      "boardMembers": "Board members",
      "boardMembersPlaceholder": "Select board members",
      "boardMembersPersonalNumberMsg": "Please provide the guarantor's personal number",
      "taxDocument": {
        "label": "Optional",
        "title": "Include Finnish tax decision or pre-completed tax return",
        "subtitle": "Four steps in MyTax, about a minute.",
        "showMeHow": "Show me how",
        "modalTitle": "How to get the document from MyTax",
        "step1": "Log in to MyTax (OmaVero) and go to the \"My taxes\" section.",
        "step2": "Go to the \"Communication\" tab and click the \"Open decisions and letters\" link.",
        "step3": "In the mailbox, you will find the \"Pre-completed tax return\" for the period ending 31 December {{year}}.",
        "step4": "Download the PDF and send it to us, thank you.",
        "dropzone": "Upload the PDF here",
        "dropzoneHint": "PDF, max 10 MB · handled confidentially",
        "chooseFile": "Choose file",
        "attached": "Tax document attached",
        "openMyTax": "Open MyTax",
        "done": "Done",
        "errorNotPdf": "The document must be a PDF.",
        "errorTooLarge": "The document must not exceed 10 MB.",
        "errorGeneric": "The upload failed. Please try again.",
        "uploadPdf": "Upload PDF",
        "previewLabel": "Tax document"
      }
    },
    "reason": {
      "reasonExplanationTitle": "Explanation of your business and financing need",
      "otherReasonLabel": "Description",
      "freetext": "May include: How you will use the funding and more about your business."
    },
    "property": {
      "options": {
        "property_unit_designation": "Property unit designation",
        "property_unit_designation_placeholder": "Property Name 2:13",
        "property_current_mortgage": "Current mortgage on the property, if any",
        "property_current_mortgage_placeholder": "Ex. \"Mortgage deeds of 2 million are available\", \"No loans\"",
        "property_valuation_label": "Value according to the latest valuation",
        "property_valuation_label_with_purchase_real_estate": "Agreed purchase price",
        "property_valuation_placeholder": {
          "SE": "5 000 000",
          "FI": "500 000"
        },
        "property_additional_data_label": "Add valuation statement",
        "property_additional_data_label_with_purchase_real_estate": "Add prospectus or valuation",
        "property_additional_data_url_label": "Link to the property",
        "property_additional_data_url_placeholder": "https://link.se/property"
      }
    },
    "propertyOwner": {
      "yes": "Yes",
      "no": "No"
    },
    "unpaidInvoices": {
      "about": {
        "newProduct": "New product",
        "heading": "Get factoring offers from multiple banks and lenders free of charge",
        "paragraph": "If your company sells through invoices you can sell invoices and receive up to 99% of the invoice value in less than a day. By answering these questions you will be able to see which factoring company will give you the best terms."
      },
      "invoiceValue": {
        "question": "Total invoice value each month",
        "placeholder": "500 000"
      },
      "numberOfInvoices": {
        "question": "Number of invoices each month",
        "previewValue": "{{count}} invoices",
        "placeholder": "15"
      },
      "averagePaymentTimeDays": {
        "question": "Average invoice due days",
        "choose": "Choose invoice due days"
      },
      "accountsLedger": {
        "question": "Example of invoices you would like to sell or accounts ledger",
        "preview": "Invoices"
      },
      "invoicesDescription": {
        "question": "Mandatory: Describe the 3 largest invoices",
        "placeholder": "Which industry, value and type of service or product",
        "preview": "Describe the 3 largest invoices"
      },
      "dueDateOptions": "{{days}} days"
    },
    "companyMortgage": {},
    "selfEstimatedHistoricRevenue": {
      "alertText": "Add an estimate for the time period",
      "infoText": "An estimate of your revenue helps lenders provide relevant offers for you.",
      "verifyRevenueTitle": "Do you want to verify the <span>revenues <helper /></span>",
      "automaticFetching": "Automatic collection",
      "helperText": "You can verify your businesses' revenues through accounting data or bank account statements. It is not compulsory to do so, but can lead to more and better offers.",
      "verify": "Verify",
      "verificationOptions": {
        "accountingFiles": {
          "title": "Upload accounting data manually"
        },
        "bankingData": {
          "title": "Bank account data"
        }
      }
    },
    "amount": {
      "valuePlaceholder": "100 000"
    },
    "repaymentTime": {
      "valuePlaceholder": "12"
    },
    "accountingData": {
      "uploadManually": "Upload manually",
      "delegateChoice": "Ask a colleague or financial manager to add",
      "upTo": "up to",
      "accountingManually": {
        "periodText": "Please provide accounting data up to <span>{{to}} <helper /></span>",
        "helper": "It is often sufficient to provide preliminary numbers. Lenders want to predominantly understand how your businesses' revenues have developed after your latest annual report."
      },
      "uploadManuallyOption": "Other / Do not know",
      "uploadLater": "Upload later",
      "tabs": {
        "upload": "Upload",
        "uploadPdf": "Upload PDF",
        "uploadSie4": "Upload SIE4",
        "invite": "Invite to upload",
        "uploadLater": "Upload later",
        "sie4Description": "Export accounting data in SIE4 format from your bookkeeping software.",
        "sie4AcceptedFileTypes": "Upload SIE4 files (.se, .si, .sie) here",
        "sie4InvalidFileType": "Please upload an SIE4 file (.se, .si or .sie)."
      }
    },
    "transactionData": {
      "shareVia": "Share your account statement simply and securely via",
      "automaticFetching": "Automatic collection",
      "uploadManually": "Upload account statement manually"
    },
    "fileUpload": {
      "uploadFilesCta": "Upload file",
      "acceptedFileTypesMessage": "Most file types are supported"
    },
    "additionalSecurities": {
      "textareaPlaceholder": "Write here (optional)",
      "attachFiles": "Attach files"
    },
    "leasing": {
      "preview": {
        "financingAmount": "Financing amount",
        "objectType": "Type of object",
        "description": "Description of the object",
        "amount": "{{amount}} (excluding VAT)",
        "offer": "Object"
      }
    },
    "isCollectedByLenderText": "This information is collected by the lender.",
    "refinancingAmounts": {
      "lenderLabel": "Lender",
      "lenderPlaceholder": "Ex. Lender Name",
      "outstandingAmountLabel": "Outstanding amount",
      "outstandingAmountPlaceholder": "Ex. 250 000 {{currency}}",
      "monthlyCostLabel": "Monthly payment (Amortisation & costs)",
      "monthlyCostPlaceholder": "Ex. 50 000 {{currency}}",
      "addFirstOpen": "Add an existing loan",
      "addMoreOpen": "Add another loan",
      "addMoreClose": "Close",
      "attachmentText": "Attach loan agreement or latest invoice",
      "close": "Close",
      "save": "Save"
    }
  },
  "advice": {
    "digital": {
      "heading": "Improve application",
      "subheading": "Suggested improvements",
      "alertText": "Application will be automatically sent to lenders in 10 minutes",
      "submitText": "Send application to lenders",
      "likelihood": "Likelihood to get approved",
      "improvementsHeading": "Provide the information below to increase the likelihood of getting approved",
      "possibleImprovements": "Possible improvements",
      "approvalChanceSummary": "Increase your approval chance from {{current}}% to {{potential}}%",
      "potentialGain": "+{{gain}}%",
      "currentLikelihood": "Likelihood to receive offers",
      "improvementPotential": "Improvement potential"
    },
    "revenue": {
      "title": "Add recent revenue numbers",
      "uploadAccountingData": "Upload accounting data manually",
      "uploadBankingData": "Bank account data",
      "uploadBankingData2": "Automatic collection with BankID",
      "noData": "I have no recent revenue numbers to share"
    },
    "manual": {
      "heading": "You qualify for our Advisory service",
      "subheading": "Next steps with your application",
      "yourAdvisor": "Your advisor",
      "advisorContactHint": "If you have any questions or need assistance, do not hesitate to reach out to your advisor.",
      "advisorIntro": "Providing the information below is optional. It helps your advisor better understand your business and prepare a stronger financing case on your behalf.",
      "whatIsAdvisory": {
        "title": "What is the Advisory service?",
        "description": "Our Debt Advisory service is designed for businesses seeking between {{minAmount}} and {{maxAmount}}. A dedicated advisor leads the entire financing process:",
        "list": {
          "item1": "In-depth credit analysis and assessment of your financing options.",
          "item2": "Preparation of a comprehensive credit case, clearly articulating your business and its potential to lenders.",
          "item3": "Structured procurement and competitive tendering of lenders.",
          "item4": "Negotiation of terms, participation in lender meetings, and execution through to disbursement."
        }
      },
      "whatHappensNext": "What happens next?",
      "daysEndToEnd": "2–5 days end to end",
      "stepsList": {
        "step1": "Your advisor contacts you",
        "step2": "We prepare a short business case",
        "step3": "We share it with relevant lenders",
        "step4": "You receive offers and pick the best"
      },
      "footer": "The whole process only takes 2-5 days until you get sharp offers",
      "submitApplication": {
        "title": "Do you need the funds faster?",
        "cta": "Submit to lenders"
      },
      "bookAdvisory": "Book advisory meeting"
    },
    "fieldRequests": {
      "heading": "Additional information for advisor support (optional)",
      "subheading": "These details help us move faster and put together a stronger case for you.",
      "timeToFinancing": {
        "timeframeLabel": "When do you need the financing?",
        "timeframePlaceholder": "Select an option",
        "targetDateLabel": "Which date?",
        "explanationLabel": "What's driving the timing?",
        "explanationPlaceholder": "Describe your timeline...",
        "helperText": "Knowing when you need the financing helps us prioritise lenders who can meet your timeline.",
        "choices": {
          "asap": "As soon as possible",
          "within_1_month": "Within 1 month",
          "within_3_months": "Within 3 months",
          "no_specific_date": "No specific date",
          "specific_date": "Specific date"
        },
        "submit": "Save"
      },
      "accountingData": {
        "helperText": "Uploading recent accounting data helps lenders and your advisor to better understand your business and identify suitable financing options.",
        "helperTextSIE4": "SIE4 files are preferred.",
        "helperTextPdf": "PDF files are preferred."
      },
      "constructionEstimate": {
        "helperText": "Upload your construction budget or project calculation."
      },
      "plPrognosis": {
        "helperText": "A forecast helps lenders understand your plans and your business. Create one, get AI help, or upload an existing forecast.",
        "tableTitle": "Profit & Loss forecast",
        "acquirerTab": "Acquiring company",
        "targetTab": "Target company",
        "draftTab": "Draft a P&L",
        "uploadTab": "Upload a file",
        "fileUploadLabel": "Upload your P&L prognosis",
        "aiAssist": {
          "open": "AI Assist",
          "preparing": "Preparing your P&L assistant...",
          "startPromptLabel": "Start P&L prognosis",
          "startPromptText": "Help me build my P&L prognosis.",
          "noAssistMode": "Use the AI Assist button on a field to get started."
        },
        "standard": {
          "revenue_excl_vat": "Revenue (excl. VAT)",
          "personnel_costs": "Personnel costs",
          "other_costs": "Other costs",
          "ebitda": "EBITDA"
        },
        "real_estate": {
          "rental_income": "Rental income",
          "operating_costs": "Operating costs",
          "property_tax": "Property tax",
          "net_operating_income": "Net operating income"
        },
        "yearSuffix": {
          "actual": "actual",
          "forecast": "forecast"
        },
        "notes": {
          "label": "Additional information for the advisor",
          "placeholder": "Any assumptions, context or other relevant information..."
        }
      }
    }
  },
  "dash": {
    "heading": "Your offers are on the way",
    "headingBidsReceived": "Choose from offers",
    "headingNoBidsReceived": "You have not received any offers so far",
    "headingBidSelected": "Your offers",
    "headingPaidOutOffers": "Paid out offers",
    "applicationHasBeenSent": "Your application has been sent to lenders.",
    "biddingOpen": "Bidding still open ({{formattedLenderTimeLeft}} left)",
    "biddingClosed": "Bidding time ended",
    "offersValidFor": "Offers are valid for {{daysLeft}} days",
    "offersValidForLessThanDay": "Offers are valid for {{hoursLeft}} hours",
    "biddingOpensSoon": "Application soon open for lenders",
    "applicationNotSubmitted": "Application not submitted yet",
    "rejectedMessage": "Contact customer service if you need assistance with your application.",
    "noBidsMessage": "You have not received any offers to your application.",
    "noBidsImproveApplicationRecommend": "We recommend that you make an application in 3 months. \n Contact customer service if you want any assistance with your application.",
    "noBidsStartNewApplication": "Start a new application",
    "biddingExpiredNoBids": {
      "title": "No offers have been received for your application.",
      "description": "Need help? Contact our customer support."
    },
    "bidsReceived": {
      "title": "You have received {{bidsCount}} financing offers.",
      "subtitle": "The official bidding time has ended for your application."
    },
    "noBindingOffersBanner": "To proceed with an offer is not binding. You can change your choice at any time.",
    "selectedBidLabel": "Chosen offer",
    "recommendedBidLabel": "Recommended",
    "paidOutBidLabel": "Paid out offer",
    "goodAlternativeBidLabel": "Good alternative",
    "promotionTitle": "Special offer",
    "promotions": {
      "amortisation_free_one": "First month without amortisation",
      "amortisation_free_other": "First {{count}} months without amortisation",
      "interest_free_one": "First month without interest",
      "interest_free_other": "First {{count}} months without interest"
    },
    "creditTerms": "Termsheet",
    "showDetails": "Details",
    "hideDetails": "Hide details",
    "sortOffers": "Sort offers",
    "bestOffer": "Best offer",
    "sortKeys": {
      "bestOffer": {
        "desc": "Best offer"
      },
      "amount": {
        "asc": "Lowest amount",
        "desc": "Highest amount"
      },
      "paybackTimeMonths": {
        "asc": "Shortest repayment time",
        "desc": "Longest repayment time"
      },
      "averageMonthlyPayment": {
        "asc": "Lowest monthly payment",
        "desc": "Highest monthly payment"
      },
      "totalLoanAmount": {
        "asc": "Lowest total amount",
        "desc": "Highest total amount"
      },
      "commissionPercent": {
        "asc": "Lowest commission",
        "desc": "Highest commission"
      },
      "withRegress": {
        "asc": "Without regress first",
        "desc": "With regress first"
      },
      "limit": {
        "asc": "Lowest credit limit",
        "desc": "Highest credit limit"
      },
      "firstMonthInterestRate": {
        "asc": "Lowest first month interest",
        "desc": "Highest first month interest"
      },
      "comparableMonthlyInterestRate": {
        "asc": "Lowest monthly interest",
        "desc": "Highest monthly interest"
      },
      "comparableYearlyInterestRate": {
        "asc": "Lowest yearly interest",
        "desc": "Highest yearly interest"
      }
    },
    "changeInformationForApplication": {
      "title": "Do you want to change the information provided in the application?",
      "back": "Back"
    },
    "closeApplicationAsCustomer": {
      "title": "Do you want to close your application?",
      "description": "If you close your application now, your current offers will no longer be available. You will need to create a new application to receive new offers.",
      "buttonText": "Close application",
      "confirmation": {
        "title": "Why do you want to close the application?",
        "selectTitle": "Select reason",
        "descriptionPlaceholder": "Describe why you want to close the application",
        "confirm": "Close application"
      }
    },
    "biddingOpenLabel": "Bidding time left",
    "countdown": {
      "day": "day",
      "days": "days",
      "hour": "hour",
      "hours": "hours",
      "minute": "minute",
      "minutes": "minutes"
    },
    "offersWillAppearHere": "Any offers will appear here.",
    "sidebar": {
      "applicationInformation": "Application information",
      "requestedAmount": "Requested amount",
      "financingAmount": "Financing amount",
      "objectType": "Type of object",
      "purpose": "Purpose",
      "repaymentTime": "Repayment time",
      "guarantors": "Guarantors",
      "property": "Property",
      "leasing": "Leasing",
      "unpaid_invoices": "Unpaid invoices",
      "editApplication": "Edit application"
    },
    "chooseBidButton": "Proceed",
    "chooseBidButtonAfterSelected": "Finalise",
    "chooseBidConfirmation": {
      "title": "Do you want to proceed with offer?",
      "additions": {
        "description1": "In order to get a contract, you will need to add the following information."
      },
      "description1": "By clicking on \"Proceed with offer\", the financing partner is informed that you are interested in the offer.",
      "description2": "This step is non-binding.",
      "cancel": "Cancel",
      "continue": "Proceed with offer",
      "modal": {
        "title": "Would you like to proceed with the offer?",
        "proceedingIsNonBinding": "Proceeding with an offer is non-binding.",
        "nextStep": "Next step:",
        "lenderWillContactYou": "{{lender}} will contact you",
        "provideFinalInformation": "Provide final information directly to {{lender}}",
        "provideMissingInformation": "Provide missing information for final credit decision",
        "proceed": "Proceed",
        "contactDetailsSharedWithLender": "Your contact details that will be shared with {{lender}}:",
        "multipleGuarantorsRequired": "Note: Requirement for {{guarantorsNumber}} guarantors with solid finances and income"
      }
    },
    "comboOffers": {
      "heading": "Combined offers",
      "description": "Combined offers: A tailored financing solution that combines two or more offer types (e.g., a business loan plus revolving credit) to address various financing needs.",
      "totalAmount": "Total amount",
      "upToAmount": "Up to {{amount}}"
    },
    "loanBids": {
      "heading": "Business loan",
      "description": "A business loan gives your company access to a fixed amount of funding that you repay over time with interest. It’s typically used to invest in growth or to support day-to-day operations.",
      "paybackTimeMonthFormat": "month",
      "paybackTimeMonthsFormat": "months",
      "columns": {
        "lender": "Lender",
        "lenderDescription": "Here you see which lender has given the loan proposal",
        "amount": "Amount",
        "approvedAmount": "Amount",
        "approvedAmountDescription": "This is the amount the lender offer you to lend. It is common that the offered amount is different from the requested amount. The reason is that the lender gives the best offer they can based on the information they have received, even if the offered amount is not the same as the requested.",
        "repaymentTime": "Repayment time",
        "repaymentTimeDescription": "Repayment time is the time period which the loan should be paid back in.",
        "averageMonthlyPayment": "Monthly payment",
        "monthlyCost": "Monthly payment",
        "monthlyCostDescription": "Monthly Payment shows the average amount which is paid to the lender per month during the payback time. Depending on the amortisation method each monthly payment may vary, but the average amount is displayed in this column.",
        "totalCost": "Total loan cost",
        "totalCostDescription": "Total cost including all costs and fees, but not the loaned amount.",
        "importantInfo": "Benefits"
      }
    },
    "factoringBids": {
      "heading": "Factoring",
      "description": "Factoring gives your company access to immediate funding by selling or pledging your invoices, instead of waiting for your customers to pay.",
      "withRegressYes": "Yes",
      "withRegressNo": "No",
      "paymentTermsDays": "days",
      "columns": {
        "factoringCompany": "Factoring company",
        "factoringCompanyDescription": "Here are the factoring companies that have left purchase invoice offers",
        "approvedAmount": "Amount",
        "approvedAmountDescription": "The offered amount is the amount you are offered to borrow from the factoring company. In case the factoring doesn't want to buy the entire invoice amount, the offered amount might be less than the invoice value you want to sell. One reason could be that the invoices are not aligned with the requirements the factoring company has - for example if the invoice recipient's credit score is too low or the invoice has a too long repayment time. Offers are not binding and it is your choice weather you want to proceed or not.",
        "commissionTime": "Commission per invoice",
        "commissionTimeDescription": "The cost per financed invoice that the factoring company takes. This includes financing, but also covers services that you get access to (such as factoring, reminders, debt collections, credit checks, etc).",
        "paidOutAmount": "Paid out amount",
        "paidOutAmountDescription": "Paid out amount specifies the amount being paid out in the first payment from the factoring company to you. Paid out amount includes all commissions, interests and fees. Sales tax (moms) will be added and must be paid on top of the compensations for the service, meaning the difference between the purchase price and invoices' nominal value plus all charged fees.",
        "regressCost": "Regress",
        "regressCostDescription": "Specifies if a factoring company has the right to reclaim payment from you if the invoice recipient doesn't pay. The regress right is usually time limited, meaning that the factoring company that reaches out to your customer for payment will require you to pay after a specified number of days. This is only if the factoring company offers invoice purchases with regress.",
        "importantInfo": "Benefits"
      }
    },
    "realEstateBids": {
      "heading": "Real estate loan",
      "description": "A real estate loan gives your company access to financing that can be used to buy, refinance, or develop a property.",
      "paybackTimeMonthFormat": "month",
      "paybackTimeMonthsFormat": "months",
      "columns": {
        "lender": "Lender",
        "lenderDescription": "Here you see which lender has given the loan proposal",
        "amount": "Amount",
        "approvedAmount": "Amount",
        "approvedAmountDescription": "This is the amount the lender offer you to lend. It is common that the offered amount is different from the requested amount. The reason is that the lender gives the best offer they can based on the information they have received, even if the offered amount is not the same as the requested.",
        "repaymentTime": "Repayment time",
        "repaymentTimeDescription": "Repayment time is the time period which the loan should be paid back in.",
        "averageMonthlyPayment": "Monthly payment",
        "monthlyCost": "Monthly payment",
        "monthlyCostDescription": "Monthly Payment shows the average amount which is paid to the lender per month during the payback time. Depending on the amortisation method each monthly payment may vary, but the average amount is displayed in this column.",
        "totalCost": "Total loan cost",
        "totalCostDescription": "Total cost including all costs and fees, but not the loaned amount.",
        "importantInfo": "Benefits"
      }
    },
    "leasingBids": {
      "heading": "Leasing",
      "description": "Leasing gives your company access to equipment or assets by paying a recurring fee over time, often with the option to purchase the asset later.",
      "columns": {
        "lender": {
          "title": "Leasing company",
          "description": "Here you see which leasing company has given the offer"
        },
        "amount": {
          "title": "Amount",
          "description": "This is the amount the leasing company has offered. The amount often corresponds to the purchasing price (excluding VAT) of the object you want to lease. The offer is non-binding and you choose if you want to proceed with it or not."
        },
        "repaymentTime": {
          "title": "Leasing period",
          "description": "Leasing period is the time (number of months) that your leasing agreement is valid for. After the contract period you can either prolong the agreement or purchase the object for the stated terminal value. For rental contracts it is even common to hand back the objects to the leasing company."
        },
        "monthlyPayment": {
          "title": "Monthly payment",
          "description": "Monthly Payment shows the average amount which is paid to the leasing company per month during the leasing period. Depending on the size of terminal value and if there is a downpayment each monthly payment may vary. The monthly payment is though the same every month during the whole leasing period."
        },
        "monthlyCost": {
          "title": "Monthly payment",
          "description": "Monthly Payment shows the average amount which is paid to the leasing company per month during the leasing period. Depending on the size of terminal value and if there is a downpayment each monthly payment may vary. The monthly payment is though the same every month during the whole leasing period."
        },
        "totalCost": {
          "title": "Total leasing cost",
          "description": "Total cost including all costs and fees, but not the down payment or the terminal value that your company might need to pay in the end of the leasing period."
        },
        "importantInfo": {
          "title": "Benefits"
        }
      }
    },
    "revolvingCreditBids": {
      "heading": "Revolving credit",
      "description": "Revolving credit gives your company access to a flexible credit limit that you can draw from as needed, with interest typically charged only on the amount used.",
      "columns": {
        "lender": {
          "title": "Lender",
          "description": "Here you see which lender has given the offer"
        },
        "limit": {
          "title": "Credit limit",
          "description": "This is the amount the lender offer you to lend. It is common that the offered amount is different from the requested amount. The reason is that the lender gives the best offer they can based on the information they have received, even if the offered amount is not the same as the requested."
        },
        "averageMonthlyPayment": {
          "title": "Monthly payment",
          "description": "Monthly Payment shows the average amount which is paid to the lender per month. For revolving credit offers we assume that the loan will be utilized with 50% in average. The size of the monthly payments will differ each month."
        },
        "amortisationPerMonth": {
          "title": "Amortisation per month",
          "description": "A revolving credit offer may have a requirement for monthly amortisation. However, after the initial repayments, you can withdraw additional funds, up to the credit limit amount."
        },
        "importantInfo": {
          "title": "Benefits"
        }
      }
    },
    "purchaseFinancingBids": {
      "heading": "Purchase financing",
      "description": "Purchase financing is a short-term loan that enables your company to procure goods or materials without draining liquidity. The financier pays the supplier upfront, and the loan is repaid in instalments over time.",
      "columns": {
        "lender": {
          "title": "Lender",
          "description": "Here you see which lender has given the offer"
        },
        "amount": {
          "title": "Amount",
          "description": "This is the amount the lender offers to finance."
        },
        "averageMonthlyPayment": {
          "title": "Monthly payment",
          "description": "Monthly payment shows the average amount which is paid to the lender per month."
        },
        "importantInfo": {
          "title": "Benefits"
        }
      }
    },
    "commonBidsColumns": {
      "comparableYearlyInterestRate": {
        "title": "Effective yearly interest",
        "description": "Effective yearly interest specifies the average cost (in percent), and includes all interests and fees. This interest rate may differ from the agreement since lenders sometimes calculate this in a different way."
      },
      "comparableMonthlyInterestRate": {
        "title": "Effective monthly interest",
        "description": "Effective monthly interest specifies the average cost (in percent), and includes all interests and fees. This interest may differ from the lender's agreement since lenders sometimes calculate this in a different way."
      },
      "firstMonthInterestRate": {
        "title": "Interest rate first month",
        "description": "Interest rate first month specifies the interest cost (in percent) under the assumption that you keep the loan only for one month. The cost does not include any potential additional fees and the interest cost might vary over the period when taking a loan."
      },
      "details": "Details"
    },
    "bidsRateToaster": {
      "text": "Your offers are shown with the offers'",
      "comparableYearlyInterestRate": {
        "selected": "effective yearly interest rate",
        "showText": "Show effective yearly interest rate"
      },
      "comparableMonthlyInterestRate": {
        "selected": "effective monthly interest rate",
        "showText": "Show effective monthly interest rate"
      },
      "firstMonthInterestRate": {
        "selected": "interest rate in the first month",
        "showText": "Show first month interest rate"
      }
    },
    "chooseOtherBid": {
      "text": "If you want to change or have any questions, contact customer service.",
      "cancelButton": "Cancel",
      "confirmButton": "Contact customer service"
    },
    "createdState": {
      "heading": "Your application has not been submitted yet"
    },
    "rejectedState": {
      "heading": "Your application has not been submitted"
    },
    "bidsRejected": {
      "heading": "We've noted that you have rejected new offers for this application.",
      "paragraphWithLinktoSupport": "If this doesn't seem right, please <1>contact customer service</1>"
    },
    "importantInfo": {
      "euLoanBidDetailsHeading": "Business loan with EU support",
      "euLoanBidDetailsText": "This loan proposal has the support of the EU, where the terms become more favorable. The loan has a lower interest rate and a limited guarantee commitment of only 20% of the loan amount. The reason is that the loan is covered by a guarantee financed by the European Union under the Employment and Social Innovation Program (EaSI)."
    },
    "messages": {
      "applicationNotSubmitted": {
        "title": "Your application has not been submitted automatically.",
        "subtitle": "Our customer service will contact you",
        "reason": "What could be the reason?",
        "description": "This could be the result of you having a prior application that is still not finalised or that you are missing signing rights for the company. Our customer service will be in touch within one working day.",
        "duplicate": {
          "title": "You have a previous application that has not been closed yet.",
          "readMoreText": "Read more",
          "readMoreModalText": "Offers from lenders on your previous application are valid for at least 30 days. We recommend continuing with the previous application if you still have active offers.",
          "subtitle": "Choose below how to proceed.",
          "continueWithApplication": {
            "title": "Continue with previous application",
            "description": "Application was created on {{creationDate}} and has {{noActiveOffers}} active offers",
            "actionText": "Continue with previous application"
          },
          "submitNewApplication": {
            "title": "Submit new application and close previous application",
            "description": "By submitting we will close your previous application. You will not be able to access any details or offers from the previous application.",
            "actionText": "Submit new application"
          }
        },
        "noSigningRights": {
          "title": "We could not automatically verify your relationship to this company from public registers.",
          "subtitle": "Please describe your connection to the company below.",
          "submitExplanationButton": "Submit",
          "explanationSubmitted": "Your explanation has been submitted. Our customer service will contact you."
        }
      },
      "rejectedByKrea": {
        "description": "This could be the result of your company not being fully registered yet or you having a prior application that is still not finalised. Our customer service will be in touch within one working day."
      },
      "applicationAdvice": {
        "title": "We have seen that similar companies to yours get better offers if they are supported by one of our advisors.",
        "subtitle": "If you want to receive advise, you will be contacted by your advisor within one working day."
      },
      "applicationSimpleManualAdvice": {
        "title": "Do you want to proceed without talking to your advisor first?",
        "subtitle": "You can submit without a phone call, but beware that it might lead to worse offers."
      },
      "applicationAdviceWaiting": {
        "title": "Your Advisor will be contacting you within one working day."
      },
      "applicationDigitalAdvice": {
        "title": "We identified possible improvements for your application.",
        "subtitle": "Improve your application by following our recommendations.",
        "subtitleAdvicePage": "These improvements may lead to better offers."
      }
    }
  },
  "bidType": {
    "COMPANY_LOAN": "Business loan",
    "FACTORING": "Factoring",
    "LEASING": "Leasing",
    "REAL_ESTATE": "Real estate loan",
    "REVOLVING_CREDIT": "Revolving credit",
    "PURCHASE_FINANCING": "Purchase financing"
  },
  "bidDetails": {
    "show": "Show details on selected offer",
    "repaymentTime": "Repayment time",
    "contractInterestMonthly": "Monthly interest rate or fee shown in contract",
    "contractInterestYearly": "Yearly interest rate shown in contract",
    "amortisation": "Amortisation type",
    "totalCost": "Total cost (interest expenses and other fees)",
    "averageMonthlyPayment": "Average monthly payment (repayment and interest cost)",
    "averageMonthlyCost": "Average monthly cost (interest cost and fees)",
    "firstMonthCost": "Cost first month (interest cost and fees)",
    "firstMonthRate": "First month",
    "monthlyRate": "Monthly",
    "yearlyRate": "Yearly",
    "earlyRepaymentFee": "Cost for early repayment",
    "repayableWithoutFee": "Free",
    "setupFee": "Setup fee",
    "postalFee": "Postal fee (per month)",
    "directDebitFee": "Direct debit fee (per month)",
    "totalCostExplainer": "All fees are included in total cost",
    "oneTimeFee": "one time fee",
    "daily": "per day",
    "weekly": "per week",
    "monthly": "per month",
    "quarterly": "per quarter",
    "yearly": "per year",
    "benefits": "Benefits",
    "importantCollateral": "Collateral",
    "additionalInformation": "Information for final credit decision:",
    "moreAbout": "More about: ",
    "registeredByFI": "Approved by Sweden's financial supervisory authority",
    "paidOutShow": "Show details of your offer",
    "paidOutStartNew": "Start a new Funding search",
    "collectedByLenderFieldRequestInfo": "Automatically collected with BankID - only takes 2-3 minutes",
    "lenderComment": "Lender comment: ",
    "alreadySubmitted": "Already submitted",
    "notSubmittedYet": "Not submitted yet",
    "submitInNextStep": "Submit in next step",
    "submitToLenderSite": "Submit to lender's site",
    "keyCalculations": "Key calculations for your offer",
    "lender": "Lender",
    "principalRepayment": "Principal repayment",
    "interestPayment": "Interest Payment",
    "monthlyPayment": "Average monthly payment",
    "firstMonthAmortisation": "First month amortisation",
    "firstMonthPayment": "Payment first month",
    "principalRepaymentPerMonth": "Principal repayment (per month)",
    "interestPaymentPerMonth": "Interest payment (per month)",
    "monthlyPaymentPerMonth": "Monthly payment (per month)",
    "costPerMonth": "Cost (per month)",
    "amount": "Amount",
    "fixedMonthlyFee": "Fixed monthly fee"
  },
  "realEstateBidDetails": {
    "repaymentTimeMonths": "Loan term"
  },
  "factoringBidDetails": {
    "show": "Show details on selected offer",
    "purchasedAmountPercent": "Financing rate (in %)",
    "purchaseLimit": "Invoice purchase limit",
    "limitFeePerYearPercent": "Limit fee (per year)",
    "setupFee": "Setup fee",
    "handlingFeePerInvoice": "Handling fee per invoice (without postage)",
    "monthlyFee": "Additional monthly fee",
    "totalMonthlyCost": "Monthly cost",
    "regressNumDaysAfterDueDate": "Regress number of days",
    "regressDaysFormat": "days",
    "totalCostExplainer": "All fees are included in total loan cost",
    "monthly": "per month"
  },
  "leasingBidDetails": {
    "downPayment": "Down payment (paid together with the first monthly payment)",
    "terminalValue": {
      "title": "Terminal value after the leasing period",
      "description": "Terminal value only applies for financial leasing contracts (i.e. not for rent). The value represents the estimated value of the object at the end of the leasing period. Once the contract expires you will be able to purchase the leasing object from the leasing company by paying the terminal value."
    },
    "setupFee": "Setup fee",
    "totalCost": "Total leasing cost",
    "totalCostExplainer": "All costs listed above are included in the total cost",
    "typeOfContract": {
      "title": "Type of contract",
      "type": {
        "leasing": {
          "title": "Leasing",
          "description": "Leasing is suitable for businesses that want to invest in new or used tools, machines or equipment without needing to buy or borrow money. In the end of the leasing period, you can either prolong the contract, purchase the object for its terminal value or return the object to the leasing company."
        },
        "rent": {
          "title": "Rent",
          "description": "Sometimes it might be more suitable to rent rather than to lease an object. Especially if you want to be able to change the equipment during the leasing period. In the end of the leasing period you can either prolong the rental agreement or return the object to the leasing company."
        }
      }
    },
    "postalFee": "Postal fee (not included in monthly payment)",
    "insuranceCostPerMonth": "Insurance cost per month (not included in monthly payment)"
  },
  "revolvingCreditBidDetails": {
    "amount": "Credit limit",
    "lenderMonthlyInterest": "Interest (per month)",
    "monthlyAmortisation": "Amortisation per month",
    "setupFee": "Setup fee",
    "postalFee": "Postal fee",
    "withdrawalFee": {
      "title": "Withdrawal fee",
      "description": "The withdrawal fee is charged each time you borrow additional funds within your approved credit limit"
    },
    "limitFeePerYear": "Limit fee per year"
  },
  "recommendedSelect": {
    "toast": {
      "heading": "You have received a good indicative offer from {{lenderCompanyName}}",
      "subheading": "This offer seems to suit your situation best. Finalise the application process to get funds paid out."
    },
    "proceedWithAnotherOfferToast": {
      "heading": "Do you want to proceed with another offer?",
      "subheading": "Make your choice below."
    }
  },
  "postSelect": {
    "heading": {
      "default": "Add information",
      "withLenderSigningUrl": "Finalise the application with {{lenderCompanyName}}",
      "withoutLenderSigningUrl": "{{lenderCompanyName}} will contact you"
    },
    "toast": {
      "requiredInformation": "Provide the required information to receive financing",
      "withLinkToLender": {
        "title": "The lender requires that you finalise the application on their website.",
        "buttonText": "Onboard on lender's website"
      },
      "withoutLinkToLender": {
        "title": "You have provided all required information.",
        "subtitle": "The lender will review your application and get back to you shortly."
      }
    },
    "offerSummary": {
      "allProvided": "All information provided",
      "missingAnswers_one": "One answer missing for a final decision.",
      "missingAnswers_other": "{{count}} answers missing for a final decision."
    },
    "requiredInformationSubtitle": "{{lenderCompanyName}} asked for this information. Answers save as you go.",
    "lenderCommentTitle": "Comment from {{lenderCompanyName}}",
    "isCollectedByLender": "Information collected by the lender in the next step",
    "customerContactInfo": {
      "heading": "Contact information for",
      "phone": "Phone number",
      "email": "Email"
    },
    "actions": {
      "nextStepCta": "Finalise and get paid out",
      "goToDashboard": {
        "title": "Would you like to see other offers?",
        "titleEligibleForPaymentNoLink": "Would you like to see all offers and continue with another lender instead?",
        "titleEligibleForPaymentWithLink": "Would you like to see all offers again?",
        "buttonText": "Back"
      },
      "createNewApplication": {
        "title": "Do you want to create a new application?",
        "buttonText": "Create new application"
      }
    },
    "lastStep": "The last step",
    "onboardAndProvideInformation": "Onboard on {{lenderCompanyName}} website and provide final information",
    "allInformationProvided": "You have provided all required information",
    "lenderWillReviewYourApplication": "The lender will review your application and get back to you shortly",
    "faq": {
      "processSteps": {
        "title": "How does the process look to receive funding?",
        "list": {
          "withLinkToLender": {
            "step1": "Proceed to the lender to complete your application: <a>Continue on the lender's website</a>",
            "step2": "The lender will review your information and may request additional details",
            "step3": "The lender will send the agreement for signing and transfer the funds to your account"
          },
          "withoutLinkToLender": {
            "step1": "The lender will review your application",
            "step2": "The lender may request any additional details needed",
            "step3": "The lender will send the agreement for signing and transfer the funds to your account"
          }
        }
      },
      "explanation": {
        "title": "How long does it take to receive funding?",
        "text": "The average time from application to receiving funds at Krea is approximately 3-10 days. For smaller financing amounts you can already receive the funds within 1-3 days."
      }
    },
    "paidOut": {
      "title": "Thank you for using our service",
      "subtitle": "According to our information you have received the funds"
    }
  },
  "bidSelected": {},
  "factoringBidSelected": {},
  "realEstateBidSelected": {},
  "delegateFieldRequest": {
    "inviteHeading": "Enter the email of the person you want to invite to add the information.",
    "personsWithAccessTitle": "People who have access to this question:",
    "revokeAccess": "Delete",
    "revokeAccessTooltip": "Removes this person's access to the question",
    "ctaButton": "Send link to email",
    "validation": {
      "invalidEmail": "Please enter a valid email."
    },
    "uploadLater": {
      "heading": "Send a link to your email so you can share the numbers later",
      "ctaButton": "Send link to your email",
      "linkWillBeSent": "A link with the question will be sent to the email address you provided",
      "helperPrompt": "Don't have the data now? <trigger>Send an email to yourself to upload later</trigger>",
      "modalTitle": "Upload later"
    }
  },
  "footer": {
    "heading": "Contact us",
    "phoneLabel": "Phone:",
    "emailLabel": "Email:",
    "addressLabel": "Address:",
    "openingHours": "Customer service opening hours",
    "mondayToThursdayLabel": {
      "SE": "Monday - Thursday",
      "FI": "Monday - Friday"
    },
    "fridayLabel": "Friday"
  },
  "cookieConsentThirdPartyApp": {
    "consent_modal": {
      "description": "We use cookies to make our service work and to improve your experience. We also share data with our advertising partners.",
      "secondary_btn": {
        "text": "Manage cookies",
        "role": "settings"
      },
      "primary_btn": {
        "text": "Accept all",
        "role": "accept_all"
      }
    },
    "settings_modal": {
      "title": "Cookie preferences",
      "save_settings_btn": "Save settings",
      "accept_all_btn": "Accept all",
      "close_btn_label": "Close",
      "blocks": [
        {
          "description": "We use cookies to ensure the basic functionalities of our service and to enhance your experience. You can choose for each category to opt-in/out whenever you want."
        },
        {
          "title": "Strictly necessary",
          "description": "These cookies are essential for the proper functioning of our website. Without these cookies, the website would not work properly and therefore they can not be turned off.",
          "toggle": {
            "value": "necessary",
            "enabled": true,
            "readonly": true
          }
        },
        {
          "title": "Performance and Analytics",
          "description": "These cookies save information about how our website is used and enable us to improve our products.",
          "toggle": {
            "value": "analytics_storage",
            "enabled": false,
            "readonly": false
          }
        },
        {
          "title": "Advertisement and Personalization",
          "description": "These cookies are used to enhance your experience on our website and for marketing purposes. By sharing this information with our marketing partners, such as Google and Microsoft, we can show more relevant information and advertisements to you. They also help us create a more personalized experience by analyzing your interaction with our website, which allows us to customize the content and offers to your preferences and interests.",
          "toggle": {
            "value": "ad_storage",
            "enabled": false,
            "readonly": false
          }
        }
      ]
    }
  },
  "remoteIdentification": {
    "factoringLabel": "Invoice purchases",
    "leasingLabel": "Leasing for",
    "reasonLabelSMS": "Reason",
    "ssnLabelSMS": "Enter social security number",
    "SMSIdentifyKrea": "Identify yourself with Krea",
    "SMSIdentifyKredita": "Identify yourself with Kredita",
    "toastText": "Please identify yourself so that we can verify that you have signing rights for",
    "identifyYourself": "Identify yourself",
    "customerView": "Customer view",
    "product": "Product",
    "copyShareableLink": "Copy shareable link",
    "copiedLink": "Copied!",
    "linkExpires": "Link expires: {{expiryDate}}",
    "fraudClientErrorPage": {
      "title": "An application could not be created.",
      "description": "You have been blocked from making new applications.",
      "descriptionNewLine": "If you are not aware of this or think this might be wrongfully so, please contact us."
    },
    "genericErrorPage": {
      "title": "Something went wrong.",
      "description": "Please try again or contact customer service."
    }
  },
  "reviewProvider": {
    "google": {
      "numberOfReviews": "{{numberOfReviews}} reviews"
    },
    "reviews": "reviews",
    "trustpilotWidget": {
      "grade": "Excellent"
    },
    "officialFinancingPartner": "Official financing partner",
    "trustMessage": "{{company}} has helped over {{businessCount}} businesses find the best financing"
  },
  "applicationProgress": {
    "title": "Application Progress",
    "tabs": {
      "progress": "Progress",
      "aiAssistant": "AI Assistant"
    },
    "step1": {
      "label": "Contact details"
    },
    "step2": {
      "label": "Financing need & identification",
      "substep1": "Purpose",
      "substep2": {
        "default": "Amount",
        "objectFinancing": "Purchase/Leasing needs",
        "invoiceFinancing": "Invoice information",
        "realEstate": "Real estate information"
      },
      "substep3": "Identification"
    },
    "step3": {
      "label": "Important information",
      "sidebarLabels": {
        "reason_explanation": "Explain your need",
        "grouped_real_estate_repayment": "Loan repayment plan",
        "self_estimated_historic_revenue": "Estimated revenue"
      }
    },
    "step4": {
      "label": "Submit & get offers"
    },
    "postSubmitTitle": "Get offers & receive funds",
    "substep": {
      "skipped": "Skipped"
    },
    "collapse": "Collapse",
    "expand": "Expand",
    "stepXofY": "Step {{current}} of {{total}}",
    "resizeSidebar": "Resize sidebar",
    "completed": "Completed",
    "completedStepTooltip": "You will be able to edit this information right before submitting",
    "editApplication": "Edit your application",
    "editApplicationPartner": "Edit customer's application"
  },
  "postSubmitProgress": {
    "step1": {
      "label": "Application"
    },
    "step2": {
      "label": "Offers",
      "tooltip": {
        "locked": "Available once the application is submitted to lenders"
      }
    },
    "step3": {
      "label": "Selected offer",
      "tooltip": {
        "locked": "Available once you have chosen an offer"
      }
    },
    "verification": {
      "label": "Verification by {{company}}"
    },
    "improveApplication": {
      "label": "Improve application"
    },
    "advice": {
      "label": "Advisory"
    }
  },
  "leaveReview": {
    "heading": "Happy with {{company}}?",
    "subtext": "Share your experience and help others find the right financing.",
    "reviews": "reviews",
    "google": {
      "cta": "Leave a Google review"
    },
    "trustpilot": {
      "cta": "Leave a Trustpilot review"
    }
  },
  "triageFields": {
    "toastTexts": {
      "reasonExplanation": {
        "title": "Before you submit",
        "subtitle": "We identified {{numberOfQuestions}} optional questions that could lead to better offers"
      },
      "refinancingAmounts": {
        "title": "You have chosen a reason that indicates you want to refinance debt.",
        "subtitle": "If your company wants to repay part of its existing financing, provide below information."
      },
      "leasingAdditionalData": {
        "title": "Fill in below to also receive leasing offers",
        "subtitle": "Leasing can be a smooth way to finance vehicles or equipment without tying up much capital up front. If you skip this, you'll still get business loan offers."
      },
      "guarantors": {
        "title": "Companies that name at least one guarantor are 3 times more likely to receive financing.",
        "subtitle": ""
      }
    }
  },
  "mobileMenu": {
    "title": "Menu",
    "language": "Language",
    "partnerRole": "Partner"
  }
}
